import { configureStore } from '@reduxjs/toolkit'
import { themeSlice } from './slices/themeSlice'
import { authSlice } from './slices/authSlice'
import { uiSlice } from './slices/uiSlice'

export const store = configureStore({
  reducer: {
    theme: themeSlice.reducer,
    auth: authSlice.reducer,
    ui: uiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Re-export everything for easier imports
export { store as default }
export * from './slices/themeSlice'
export * from './slices/authSlice'
export * from './slices/uiSlice'
// Both authSlice and uiSlice export a `setLoading` action; the star exports
// above would make the name ambiguous. Explicitly re-export the auth one
// (import from the slice directly if you need the ui variant).
export { setLoading } from './slices/authSlice'